import {
  getCookieOrWebStorage,
  removeCookieOrWebStorage,
  setCookieOrWebStorage
} from '../global/_cookies';

const returnToOriginalPos = (key) => {
  if (getCookieOrWebStorage(key) !== null && getCookieOrWebStorage(key) !== undefined) {
    window.scrollTo(0, getCookieOrWebStorage(key));
    removeCookieOrWebStorage(key);
  }
}

const keepRegLoc = () => {
  returnToOriginalPos('regPos');
  $('#manageRegistryItemsUpdate .shopper_actions .btn-reg').on('click', function() {
    setCookieOrWebStorage('sessionStorage', 'regPos', $(document).scrollTop());
  });
  $('.remove-item-modal-view #removeNoClick').on('click', function() {
    returnToOriginalPos('regPos');
  });
  if ($('.mobilePage').length > 0) {
    $('.regATB').on('click', function() {
      setCookieOrWebStorage('sessionStorage', 'regPos', $(document).scrollTop());
    });
    $('.regContinue').on('click', function() {
      returnToOriginalPos('regPos');
    });
  }
}

export {
  keepRegLoc,
  returnToOriginalPos
}
